import React, { useState, useEffect } from 'react';
import "../css/PopUpBanner.css";
/**
 * Componente: FullWidthBanner
 * - Ocupa el 100% del ancho de la pantalla.
 * - Posición relativa (fluye con el contenido, no es fixed).
 * - Desaparece automáticamente tras 60 segundos (1 minuto).
 * - Incluye botón de cierre manual y barra de progreso.
 */
const PopUpBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  const DISPLAY_DURATION = 60000; // 60 segundos (1 minuto)

  useEffect(() => {
    // Iniciar la animación de la barra de progreso casi inmediatamente
    const animTimer = setTimeout(() => {
      setIsAnimating(true);
    }, 100);

    // Temporizador para eliminar el componente tras 1 minuto
    const autoCloseTimer = setTimeout(() => {
      setIsVisible(false);
    }, DISPLAY_DURATION);

    return () => {
      clearTimeout(animTimer);
      clearTimeout(autoCloseTimer);
    };
  }, []);

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="banner-page-wrapper">


      {/* Estructura del Banner */}
      <section className="full-width-banner">
        <button 
          className="banner-close-btn" 
          onClick={handleClose}
          aria-label="Cerrar banner"
        >
          &times;
        </button>

        <a 
          href="https://www.youtube.com/watch?v=qa09Px6jMVg" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="banner-link"
        >
          <img 
            src="https://www.utpl.edu.ec/carreras/sites/default/files/banner-horarios.png" 
            alt="Fondo promocional" 
            className="banner-image"
          />
          
         
          {/* Barra de progreso de 1 minuto */}
          <div className="banner-progress-bg">
            <div 
              className="banner-progress-fill"
              style={{ 
                width: isAnimating ? '0%' : '100%',
                transitionDuration: isAnimating ? `${DISPLAY_DURATION}ms` : '0ms'
              }}
            />
          </div>
        </a>
      </section>

   
    </div>
  );
};

export default PopUpBanner;